<template>
  <div id="NavBar">
    <van-nav-bar
      :title="title"
      left-text="返回"
      style="background-color: #393a3f; color: white"
      :left-arrow="isleftarrow"
      @click-left="onClickLeft"
    />
  </div>
</template>

<script>
export default {
  // title：用来显示导航栏的title，isleftarrow用来显示导航栏的左侧返回箭头
  props: {
    title: {
      type: String,
      default: '',
    },
    isleftarrow: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onClickLeft() {
      // 点击回退的时候当做地址回退
      // this.$router.go(-1)
      this.$emit('onClickLeft')
    },
  },
}
</script>

<style lang="less" scoped>
#NavBar {
  /* position: fixed;
  top: 0;
  left: 0; */
  height: 46px;
  line-height: 46px;
  width: 100%;
  z-index: 100;
}

.van-nav-bar {
  font-size: 18px !important;
  border: 0;
}

.van-hairline--bottom::after {
  /* 去除导航栏底部的白色横线 */
  border-bottom-width: 0px !important;
}

::v-deep .van-nav-bar__title {
  color: white;
}

::v-deep .van-nav-bar .van-icon {
  color: white;
}

::v-deep .van-nav-bar__text {
  color: white;
}
</style>